/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BindingTargetEsercente } from './binding-target-esercente';
import { UiWidget } from './ui-widget';
import { ValidationType } from './validation-type';


export interface TipoPraticaAttributoEsercenteCreationForm { 
    chiave: string;
    binding: BindingTargetEsercente;
    ui_widget: UiWidget;
    validation_type: ValidationType;
    component_label?: string;
    component_description?: string;
    component_placeholder?: string;
    component_hint?: string;
    abilitato?: boolean;
    obbligatorio?: boolean;
    autofill?: boolean;
    ordine?: number;
    min_value?: string;
    max_value?: string;
    abilita_testo?: boolean;
    abilita_picker?: boolean;
    regex?: string;
    regex_error_message?: string;
    accept_file?: string;
    max_size_file_in_byte?: number;
    currency_symbol?: string;
    currency_decimal?: number;
    currency_thousands?: string;
}



